import axios from "axios";

function errorHandler(error, reject) {
  if (error.response && error.response.data) {
    reject(error.response.data);
  } else {
    reject(error);
  }
}

export default {
  crewdepartemen(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["page", "limit", "sortBy", "sortDir"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        if (obj.customQuery) {
          str += str ? "&" : "?";
          str += obj.customQuery;
        }

        axios({
          url: `/crudexport/crewdepartemen${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "department.xlsx");
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  crewgolongan(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["page", "limit", "sortBy", "sortDir"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        if (obj.customQuery) {
          str += str ? "&" : "?";
          str += obj.customQuery;
        }

        axios({
          url: `/crudexport/crewgolongan${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Job_Group_Grade.xlsx");
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  crewpangkat(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["page", "limit", "sortBy", "sortDir"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        if (obj.customQuery) {
          str += str ? "&" : "?";
          str += obj.customQuery;
        }

        axios({
          url: `/crudexport/crewpangkat${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Job_Position.xlsx");
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  mstradvbrand(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["page", "limit", "sortBy", "sortDir"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        if (obj.customQuery) {
          str += str ? "&" : "?";
          str += obj.customQuery;
        }

        axios({
          url: `/crudexport/mstradvbrand${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "advertiser_brand.xlsx");
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  mstradvcategory(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["page", "limit", "sortBy", "sortDir"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        if (obj.customQuery) {
          str += str ? "&" : "?";
          str += obj.customQuery;
        }

        axios({
          url: `/crudexport/mstradvcategory${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "advertiser_category.xlsx");
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  notification(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["page", "limit", "sortBy", "sortDir"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        if (obj.customQuery) {
          str += str ? "&" : "?";
          str += obj.customQuery;
        }

        axios({
          url: `/crudexport/notification${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "notification.xlsx");
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
};
